<template>
    <b-col>
        <small>
            <b>{{ title }}</b>
            <hr class="my-1" />
            <b-form-group label="">
                <label
                    v-for="option in options"
                    :key="option.value"
                    :active="value === option.value"
                    class="filter-item-option"
                    >
                    <input
                    :checked="value === option.value"
                    :value="option.value"
                    type="radio"
                    @input="$emit('input', option.value)"
                    /><span class="filter-item-option-text">{{ option.text }}</span>
                </label>
            </b-form-group>
        </small>
    </b-col>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true,
            default() {
                return ''
            },
        },
        title: {
            type: String,
            required: true,
            default() {
                return ''
            },
        },
        options: {
            type: Array,
            required: true,
            default() {
                return []
            },
        },
    },
    data() {
        return {}
    },
    computed: {},
    async mounted() {},
    methods: {},
}
</script>

<style lang="scss" scoped>
.filter-item-option {
    display: block;

    &[active] {
    }

    &:not([active]) {
        opacity: 0.3;
    }

    [type='radio'] {
        display: none;
    }

    .filter-item-option-text {
        cursor: pointer;
    }
}
</style>


